import React, { useCallback, useMemo } from 'react';
import { ColumnsType } from 'antd/es/table';
import { Column, DataTable, Label } from '@ydistri/ds';
import ActualDataWrapper from './ActualDataWrapper';

export interface SkuAttribute {
  label: string;
  value: React.ReactNode;
  secondaryValue?: React.ReactNode;
}

interface SkuAttributesProps {
  attributes: SkuAttribute[];
  showActualData?: boolean;
}

const SkuAttributes: React.FC<SkuAttributesProps> = ({ attributes, showActualData }) => {
  const rowKeyProvider = useCallback((record: SkuAttribute) => record.label, []);

  const columns = useMemo(() => {
    const columns: ColumnsType<SkuAttribute> = [
      {
        dataIndex: 'label',
        key: 'label',
        title: 'Attributes',
        width: '18rem',
        render: (value: string) => <Label>{value}</Label>,
      },
      {
        dataIndex: 'value',
        key: 'value',
        title: '',
        width: '11rem',
        render: (value: React.ReactNode) =>
          showActualData ? <ActualDataWrapper>{value}</ActualDataWrapper> : value,
      },
      {
        dataIndex: 'secondaryValue',
        key: 'secondary-value',
        title: '',
        render: (value: React.ReactNode) =>
          showActualData ? <ActualDataWrapper>{value}</ActualDataWrapper> : value,
      },
    ];

    return columns;
  }, [showActualData]);

  return (
    <Column>
      <DataTable
        id="SkuAttributes"
        dataSource={attributes}
        columns={columns}
        showHeader={true}
        rowKey={rowKeyProvider}
      />
    </Column>
  );
};

export default SkuAttributes;
